module.exports = __webpack_public_path__ + "static/media/h15_tcm_bw.d8beed16.webp";